import React from "react";
import { useNavigate } from "react-router-dom";

const RegModal = ({activeModal, setActiveModal}) => {

    const navigate = useNavigate();

    function onAuthPageClick () {
        setActiveModal(false)
        navigate('/auth');
    }

    return (
        <div className={activeModal ? 'registration-modal active' : 'registration-modal'}>
            <div className={'registration-modal__content'}>
                <h4>You have registered!</h4>
                <button type={'button'} onClick={onAuthPageClick}>To main</button>
            </div>
        </div>
    )
}
export default RegModal;